import React from 'react';
import { Container, Row, Col, Card, Alert } from 'react-bootstrap';

const ClubOfficeInfo = () => {
  return (
    <Container className="mt-5">
      <Row>
        <Col>
          <Card className="shadow-sm">
            <Card.Body>
              <Card.Title className="text-center">
                <h3>Club Office Information</h3>
              </Card.Title>
              <Card.Text>
                <p>
                  Welcome to the Club! Below are the office timings and important information:
                </p>
                <h5>Club Office Timings</h5>
                <ul style={{listStyle:"none"}}>
                  <li><strong>Indoor Sports Facilities : </strong> 6:00 AM- 10:00 AM Morning / 04.00 PM - 10.00 PM Evening</li>
                  <li><strong>	Club Hours :</strong> 16.00 Hrs. to 22.00 Hrs. in Evening</li>
                  <li><strong>Residential Accommodation:</strong> 24 Hrs</li>
                </ul>
                
                 <h5>Address</h5>
                <div className='container '>
                  
                <p>
Mahaveer Marg, C-Scheme, Jaipur
Located at the heart of the city – 4 KM from Railway Station, 3 KM from Sindhi Camp Bus Stand & 9 Km from Airport
    </p>
                </div>
                <h5>Contact Information</h5>
                <ul style={{listStyle:"none"}}>
                  <li><strong>Email:</strong> <a href="mailto:info@club.com">jaiclub@hotmail.com</a></li>
                  <li><strong>Phone:</strong> 0141-2372321, 2372322, </li>
                </ul>
              </Card.Text>
              <Alert variant="info">
                <strong>Note:</strong> The club office will remain Open all days. Please check the website for updates.
              </Alert>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ClubOfficeInfo;
